import { LoadingButton } from '@mui/lab';
import { Button, Stack, TextField } from '@mui/material';
import type { KeyboardEvent } from 'react';

interface MacroCreateFolderRowProps {
  name: string;
  isLoading: boolean;
  onChangeName: (value: string) => void;
  onCreate: () => void;
  onCancel: () => void;
}

export const MacroCreateFolderRow = ({
  name,
  isLoading,
  onChangeName,
  onCreate,
  onCancel,
}: MacroCreateFolderRowProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && name.trim() && !isLoading) {
      event.preventDefault();
      onCreate();
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      onCancel();
    }
  };

  return (
    <Stack direction="row" gap={1} alignItems="center" padding={3}>
      <TextField
        fullWidth
        size="small"
        variant="outlined"
        label="New folder name"
        value={name}
        onChange={(event) => onChangeName(event.target.value)}
        onKeyDown={handleKeyDown}
      />
      <LoadingButton
        loading={isLoading}
        disabled={!name.trim()}
        onClick={onCreate}
        variant="contained"
      >
        Create
      </LoadingButton>
      <Button variant="text" onClick={onCancel}>
        Cancel
      </Button>
    </Stack>
  );
};
